<template>
  <div class="grassmaker">
    <Grass v-for="n in total" :key="n" :ref="`grass_${n}`" :num="n" :pattern="pattern[n-1]" :growPos="growPos_update(growPos, n)"></Grass>
  </div>
</template>

<script>
import Grass from './Grass.vue'
export default {
  name: 'Grassmaker',
  data () {
    return {
      growPos: [],
      pattern: [],
      total: 7
    }
  },
  methods: {
    getnum (i) {
      const e = i - 1
      if (e < 0) {
        return 0
      } else {
        return e
      }
    },
    shuffle (o) {
      for (
        var j, x, i = o.length;
        i;
        j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x
      );
      return o
    },
    growPos_update (a, i) {
      if (i > 1 && this.growPos.length >= this.total) {
        let sum = 0
        for (let j = 0; j < i - 1; j++) {
          sum += a[j]
          // console.log(`add: ${sum}`)
        }
        return sum
      } else {
        return 0
      }
    }
  },
  components: {
    Grass
  },
  mounted () {
    this.growPos = []
    const numbers = [0, 1, 2, 3, 4, 5, 6]
    this.pattern = this.shuffle(numbers)
    // console.log(this.pattern)
  }
}
</script>

<style lang="scss" scoped>
.grassmaker {
  position: relative;
  width: 100vw;
  height: 600px;
  &.ss_16{
    height: 700px;
  }
  @include respond-to(sm) {
    height: 800px;
    &.ss_16{
      height: 800px;
    }
  }
  @include respond-to('1200') {
    height: 100vh;
    &.ss_16{
      height: 100vh;
    }
  }
  flex-shrink: 0;
}
</style>
